import { isFieldHidden } from "../FormFieldsV3/FormFIeldsV3Decorators";
import { NUMERIC_FIELD_TYPES } from "./createPayload";

export const hasValue = (value: any): boolean => {
   if (value === undefined || value === null) return false;
   if (typeof value === "string") return value.trim().length > 0;
   if (Array.isArray(value)) return value.length > 0;

   if (typeof value === "object") {
      if ("value" in value) return hasValue(value.value);
      if ("originalValue" in value) return hasValue(value.originalValue);
      if ("label" in value) return hasValue(value.label);
      return Object.keys(value).length > 0;
   }

   return true;
};

export const getRequiredFieldIds = (formResponseData: any) => {
   return (formResponseData?.fields ?? []).reduce((ids: string[], field: any) => {
      if (isFieldHidden(field)) return ids;

      const isRequired =
         field.decorators?.some(
            (decorator: any) =>
               decorator.name === "RequiredDecorator" && decorator.properties?.required === true,
         ) ?? false;

      if (isRequired) ids.push(field.id);
      return ids;
   }, []);
};

export const validateMissingRequired = (requiredFieldIds: string[], fieldsValue: any) => {
   if (!requiredFieldIds?.length) return [];
   return requiredFieldIds.filter((fieldId) => !hasValue(fieldsValue?.[fieldId]));
};

export const addNumericFieldErrors = ({
   validationErrorsByFieldId,
   formFields,
   currentFormData,
   requiredIdsToValidate,
   intl,
}: {
   validationErrorsByFieldId: Record<string, any>;
   formFields: any[];
   currentFormData: Record<string, any>;
   requiredIdsToValidate: string[];
   intl: any;
}) => {
   const requiredIdsSet = new Set((requiredIdsToValidate ?? []).map(String));

   const numericFieldsToValidate = [...(formFields ?? [])].filter((field) => {
      if (!field?.id) return false;
      if (isFieldHidden(field)) return false;

      const hasAnyValue = hasValue(currentFormData?.[field.id]);
      const isRequired = requiredIdsSet.has(String(field.id));
      if (!isRequired && !hasAnyValue) return false;

      return NUMERIC_FIELD_TYPES.has(field?.type);
   });

   numericFieldsToValidate.forEach((field) => {
      const currentFieldValue = currentFormData?.[field.id];
      if (isNaN(Number(currentFieldValue))) {
         validationErrorsByFieldId[field.id] = [
            intl.formatMessage({ id: "form.fieldShouldBeNumber" }),
         ];
      }
   });
};
